import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The greatest casual game ever devised",
  "description": "",
  "published": "2010-01-06T00:00:00.000Z",
  "redirect_from": ["/blog/the-greatest-casual-game-ever-devised/swizec/1058"],
  "categories": "Digital rights management, Downloads, Games, intrigues, life, Puzzle, Uncategorized, Video game",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239467371"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4239467371_544c36b1ec_m.jpg",
              "alt": "Machinarium 2009-10-20 02-22-26-27",
              "title": "Machinarium 2009-10-20 02-22-26-27"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239467371"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240288076"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4240288076_ed0295c6db_m.jpg",
              "alt": "Machinarium 2009-10-21 03-01-19-71",
              "title": "Machinarium 2009-10-21 03-01-19-71"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240288076"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240229860"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4240229860_6765caab5f_m.jpg",
              "alt": "Machinarium 2009-10-20 03-35-26-50",
              "title": "Machinarium 2009-10-20 03-35-26-50"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240229860"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240224898"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4240224898_6a358bc6c9_m.jpg",
              "alt": "Machinarium 2009-10-20 02-42-19-66",
              "title": "Machinarium 2009-10-20 02-42-19-66"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4240224898"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239506225"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4239506225_3770d2b598_m.jpg",
              "alt": "Machinarium 2009-10-21 02-57-02-40",
              "title": "Machinarium 2009-10-21 02-57-02-40"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239506225"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239434615"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/01/4239434615_b1222ecde2_m.jpg",
              "alt": "Machinarium 2009-10-20 01-28-26-39",
              "title": "Machinarium 2009-10-20 01-28-26-39"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/50598806@N00/4239434615"
          }}>{`deadman009`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Now and anon I like to fire up a game when I'm feeling a dash unmotivated to do pretty much anything. Most often I simply don't have time to play, so when I do play I want the game to be something fascinatingly epic but in such a way as can be enjoyed ten minutes here, twenty minutes there, an hour over yonder. NOT something you have to play for three hours straight before you get in the groove.`}</p>
    <p>{`Two nights ago I discovered `}<a parentName="p" {...{
        "href": "http://machinarium.com/",
        "title": "Machinarium"
      }}>{`Machinarium`}</a>{` through a hapless link in a msn chat.`}</p>
    <p>{`I was instantly hooked, the art is simply amazing, the level of detail beyond all comparison. The gameplay itself. Oh! Don't get me started, I could `}{`*`}{`gasm all over at the mere thought of the brilliance therein.`}</p>
    <p>{`Basically you play a robot that goes through a few adventures and solves many a puzzle in a beautifully designed world to, well I dont' know what yet, haven't gotten that far. It would seem though that it's got something to do with love because whenever his memories are shown they're about a lady robot.`}</p>
    <p>{`It is also one of the hardest `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Puzzle_video_game",
        "title": "Puzzle video game"
      }}>{`puzzle games`}</a>{` I've ever had the pleasure of playing. Shivers, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Monkey_Island_%28series%29",
        "title": "Monkey Island (series)"
      }}>{`Monkey Island`}</a>{`, Abe's Oddysee/Exoddus? Don't get me started, `}<em parentName="p">{`weaksauce`}</em>{` in comparison to Machinarium! Downright bloody weaksauce! Often you will encounter a proper logic game, one as can be bought in stores sometimes, you've got to solve just to open a door.`}</p>
    <p>{`Other times you are left solving five puzzles just to get to an item that solves a previous puzzle.`}</p>
    <p>{`The best thing though? It's absolutely `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Digital_rights_management",
        "title": "Digital rights management"
      }}>{`DRM`}</a>{` and any and all copy protection free. Buy the game, get the downloads for all OS's and a soundtrack! Yay! How could I resist? So I didn't, I shelved out the few euro it takes and it was possibly one of the best moneys ever spent.`}</p>
    <p>{`Big `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Video_game_publisher",
        "title": "Video game publisher"
      }}>{`game publisher`}</a>{`, if you are reading this, yes, yes I do only buy games if they come without DRM. Sometimes I `}<em parentName="p">{`consider`}</em>{` buying a big-name game, but usually get disappointed by the process half-way through and bail.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/abb3af50-5404-4c7c-8508-df48756a4920/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=abb3af50-5404-4c7c-8508-df48756a4920",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      